import { DISABLED_DATES } from '@code/innovance-react-ui-kit';
import React, { FC } from 'react';
import { Controller } from 'react-hook-form';
import { UseFormMethods } from 'react-hook-form/dist/types/form';
import { FormElement } from 'src/front/components/FormStyles';
import { useTranslation } from 'react-i18next';
import Datepicker from 'src/front/components/Datepicker';
import { IdentityFormData } from 'src/front/components/identity/IdentityFormData';
import { EXPIRE_DATE_RANGE } from 'src/front/constant';

interface Props {
  formMethods: UseFormMethods<IdentityFormData>;
  onChangeHandler: (fieldName: 'expireDate') => (date: Date) => void;
}
const ExpiredDate: FC<Props> = ({ formMethods, onChangeHandler }) => {
  const { control, errors } = formMethods;
  const { t } = useTranslation();

  return (
    <FormElement>
      <Controller
        control={control}
        name="expireDate"
        render={({ onChange, value }) => (
          <Datepicker
            disabledDates={DISABLED_DATES.UNTIL_TODAY_INCLUDING}
            errorMessage={t(errors?.expireDate?.message as string)}
            inputLabel={`${t('general_expiredDate_label')} *`}
            onChange={(date) => {
              onChange(date);
              onChangeHandler('expireDate')(date as Date);
            }}
            rangeYear={EXPIRE_DATE_RANGE}
            value={value as Date}
          />
        )}
      />
    </FormElement>
  );
};

export default ExpiredDate;
